import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InputModule } from './input/input.module';
import { PipesModule } from './pipes/pipes.module';
import { AntModule } from './ant/ant.module';
import { ViewModule } from './view/view.module';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { NzTreeViewModule } from 'ng-zorro-antd/tree-view';
import { NzIconModule } from 'ng-zorro-antd/icon';

@NgModule({
  declarations: [],
  imports: [CommonModule],
  exports: [
    InputModule,
    PipesModule,
    AntModule,
    ViewModule,
    ReactiveFormsModule,
    FormsModule,
    NzIconModule,
    NzTreeViewModule,
  ],
})
export class SharedModule {}
